var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMath(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 100,
    viewBox: "0 0 101 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50.5,
    cy: 50,
    r: 50,
    fill: "#FDFEFE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.3127 48.2077L53.2918 40.1868L56.5002 36.9785L61.3127 41.791L70.9377 32.166L74.146 35.3743L61.3127 48.2077ZM48.7085 39.041H28.0835V43.6243H48.7085V39.041ZM71.6252 53.7077L68.4168 50.4993L62.4585 56.4577L56.5002 50.4993L53.2918 53.7077L59.2502 59.666L53.2918 65.6243L56.5002 68.8327L62.4585 62.8743L68.4168 68.8327L71.6252 65.6243L65.6668 59.666L71.6252 53.7077ZM48.7085 57.3743H28.0835V61.9577H48.7085V57.3743Z",
    fill: "#0040BF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMath);
export default __webpack_public_path__ + "static/media/math.9d1a525cc1c9834f4e7ae969ae681adc.svg";
export { ForwardRef as ReactComponent };